import { RequestService } from '../../../../../common/services/RequestService';
import { UPDATE_ORDER } from '../constants';
import {
  dataAdjustmentResponse,
  dataCreateOrderRequest,
} from './dataAdjustment';

export const updateOrderRequest = async (profileId, data) => {
  const response = await RequestService.put(
    UPDATE_ORDER.replace('{profile_id}', profileId).replace(
      '{order_id}',
      data.orderId
    ),
    dataCreateOrderRequest(data)
  );
  return dataAdjustmentResponse(response.data.order);
};
